import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, primaryGradient, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Switch', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,

      [`&${componentCls}&${componentCls}-checked`]: {
        '&, &:hover, &:focus': {
          background: `${primaryGradient} !important`,
          boxShadow: `0 2px 8px ${purple[600]}30`,
        },
      },
    },
  }
})
